export type LayerId = "mind" | "heart" | "will";
export type Side = "player" | "enemy";
/** confusion = morph rebound; doubt = conviction onion; dogma = typed peel march. */
export type LieType = "fear" | "despair" | "confusion" | "doubt" | "dogma";
/** wisdom meets Doubt and Dogma's current demand when that demand is Wisdom. */
export type Category = "faith" | "peace" | "wisdom";
export type Difficulty = "easy" | "standard" | "hard";

/** Truth ← negative … 0 contested … positive → Lie */
export type Tilt = number;

export const LAYER_ORDER: LayerId[] = ["mind", "heart", "will"];
export const LAYER_LABELS: Record<LayerId, string> = {
  mind: "Mind",
  heart: "Heart",
  will: "Will",
};
export const SLOT_COUNT = 3;

/** Mind (0) is outer; Will (2) is inner toward Secret Place. */
export function layerIndex(id: LayerId): number {
  return LAYER_ORDER.indexOf(id);
}

/** Next layer toward Secret Place (Mind→Heart→Will). */
export function layerInward(id: LayerId): LayerId | null {
  const i = layerIndex(id);
  if (i < 0 || i >= LAYER_ORDER.length - 1) return null;
  return LAYER_ORDER[i + 1]!;
}

/** Next layer outward (Will→Heart→Mind). */
export function layerOutward(id: LayerId): LayerId | null {
  const i = layerIndex(id);
  if (i <= 0) return null;
  return LAYER_ORDER[i - 1]!;
}

export function layersAdjacent(a: LayerId, b: LayerId): boolean {
  return Math.abs(layerIndex(a) - layerIndex(b)) === 1;
}

/** Same column or an immediate neighbor (wings touch center; wings do not touch). */
export function slotsAdjacent(a: number, b: number): boolean {
  return Math.abs(a - b) <= 1;
}
